import DOMPurify from 'dompurify'

export const sanitizeHtml = html =>
  DOMPurify.sanitize(html, {
    ALLOWED_TAGS: ['p', 'ul', 'ol', 'li', 'em', 'strong', 'u', 'a'],
    ALLOWED_ATTR: ['href', 'target', 'rel']
  })

export const urlifyHTML = text => {
  const urlRegex = /https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)/g
  return text.replace(urlRegex, url => {
    return `<a href="${url}" target="_blank" rel="noreferrer noopener">${url}</a>`
  })
}

export const hexToRgb = hex => {
  let result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex)
  return result
    ? {
        r: parseInt(result[1], 16),
        g: parseInt(result[2], 16),
        b: parseInt(result[3], 16)
      }
    : null
}

const titleSize = (n, fontSize) =>
  fontSize === 'small'
    ? n
    : fontSize === 'medium'
    ? n * 1.1
    : fontSize === 'large'
    ? n * 1.2
    : n

const textSize = (n, fontSize) =>
  fontSize === 'small'
    ? n
    : fontSize === 'medium'
    ? n * 1.4
    : fontSize === 'large'
    ? n * 1.8
    : n

export const generateSizeFn = (n, options = {}, data, fn) => {
  n =
    options.scaleFactor === 'sm'
      ? titleSize(n, data.fontSize)
      : options.scaleFactor === 'lg'
      ? textSize(n, data.fontSize)
      : n
  return fn(n)
}
